import React from "react";
import { LOGO } from "../../image-links";
import {
  HEADER_FONT,
  PRIMARY_COLOR,
  TITLE_COLOR,
  TRANSPARENT,
} from "../../theme";
import { NavBar } from "./Nav.styles";
import { SITE_URL } from "../../constants";

const Nav = () => {
  const links = [
    {
      to: `${SITE_URL}/about`,
      title: "About us",
      useFullInternalLink: true,
    },
    // {
    //   to: "/articles",
    //   title: "Articles",
    //   useFullInternalLink: true,
    // },
  ];

  return (
    <NavBar
      logo={LOGO}
      mobileLogo={LOGO}
      links={links}
      headerColor={TRANSPARENT}
      menuItemColor={TITLE_COLOR}
      menuColor={PRIMARY_COLOR}
      menuIconColor={TITLE_COLOR}
      font={HEADER_FONT}
    />
  );
};

export default Nav;
